import moment from 'moment';
import {NotFound} from 'src/shared/components/icons';
import MainUtils from 'src/shared/utils/main';

export const dateFormat = (value: string, formatName?: string) => {
  if (!MainUtils.isEmptyValue(value))
    return value.endsWith('Z')
      ? moment(new Date(value)).format(formatName)
      : moment(new Date(`${value}`)).format(formatName);
  else return <NotFound />;
};
